// extracted by mini-css-extract-plugin
export var actionButton = "table-module--action-button--17fee";
export var actionColumn = "table-module--action-column--400ae";
export var categoryText = "table-module--category-text--71fcc";
export var cellLineId = "table-module--cell-line-id--7e67a";
export var certIcon = "table-module--cert-icon--1be6c";
export var cloneNumber = "table-module--clone-number--d5419";
export var clones = "table-module--clones--a1e50";
export var comingSoon = "table-module--coming-soon--50c70";
export var container = "table-module--container--5ef96";
export var dataComplete = "table-module--data-complete--2ee92";
export var disabled = "table-module--disabled--e6c19";
export var emptyMessage = "table-module--empty-message--f8c55";
export var expandableContent = "table-module--expandable-content--f346b";
export var footer = "table-module--footer--ca631";
export var gene = "table-module--gene--035db";
export var hoveredRow = "table-module--hovered-row--c5075";
export var idHeader = "table-module--id-header--8dd14";
export var idTitle = "table-module--id-title--21a79";
export var lastColumn = "table-module--last-column--f0c9b";
export var link = "table-module--link--88bff";
export var protein = "table-module--protein--53d21";
export var snpColumn = "table-module--snp-column--ff2e0";
export var structure = "table-module--structure--febba";
export var tableMultiLineCell = "table-module--table-multi-line-cell--1804c";
export var tableTitle = "table-module--table-title--77b07";
export var thumbnailContainer = "table-module--thumbnail-container--609e7";
export var tooltip = "table-module--tooltip--b18f6";
export var truncatedText = "table-module--truncated-text--1c58c";